/**
 * Lustro `PlannedTransactionPaymentStatus` z backendu. Statusu „opłacone po
 * terminie” tam nie ma — kalkulator pokrywa raty kumulatywnie i zna wyłącznie
 * te cztery stany.
 */
export enum PlannedTransactionPaymentStatus {
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  PAID = 'PAID',
  OVERDUE = 'OVERDUE',
  CANCELLED = 'CANCELLED',
}
